enum statusEnum {
	OK = 'OK'
}

export default statusEnum